export default __webpack_public_path__ + "static/media/google_logo.45446013.svg";